import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { FilingChunk } from "../models/FilingChunk";

export const useGetFilingSource = () => {
  const {
    data: source,
    call,
    isLoading,
    isFailed,
    setData: setSource,
  } = useApiPrivateRequest<FilingChunk>(
    (response) => new FilingChunk(response),
  );
  const getFilingSource = async (filingId: string, chunkId?: number) => {
    await call(`/filings/${filingId}/source`, "GET", {
      chunkId,
    });
  };

  return { source, getFilingSource, isLoading, isFailed, setSource };
};
